import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { authApi } from '../auth.api';
import { selectIsAuthenticated, useAuthStore } from '../auth.store';

/**
 * Mantiene sincronizada la sesión local con el backend.
 *
 * Sirve para reflejar cambios hechos por un administrador (permisos, grupos,
 * desactivación de la cuenta) sin obligar al usuario a volver a iniciar sesión.
 */
export function useSession() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const setUser = useAuthStore((state) => state.setUser);

  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: ({ signal }) => authApi.me(signal),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
    retry: 1,
  });

  useEffect(() => {
    if (query.data?.user) {
      setUser(query.data.user);
    }
  }, [query.data, setUser]);

  return query;
}
